import { render, staticRenderFns } from "./PosturaListPendingByIdSpecimen.vue?vue&type=template&id=be98f702"
import script from "./PosturaListPendingByIdSpecimen.vue?vue&type=script&lang=js"
export * from "./PosturaListPendingByIdSpecimen.vue?vue&type=script&lang=js"
import style0 from "./PosturaListPendingByIdSpecimen.vue?vue&type=style&index=0&id=be98f702&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports